module.exports = __webpack_public_path__ + "static/rauma-horseshoe-cfc8565b45c0a1d3e1cb1e6d883b7c5d.jpg";